import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

export const useProductTypes = () => {
  const storeId = useStoreId();
  const queryKey = ['product', 'types', storeId];

  return useQuery({
    queryKey,
    queryFn: () => api.store(storeId).product.types(),
  });
};
